import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-scheduled-maintenance',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './scheduled-maintenance.component.html',
  styleUrls: ['./scheduled-maintenance.component.scss']
})
export class ScheduledMaintenanceComponent {}
